export default[
  {
      path: '/dataList/integralOrder',
      component: resolve => require(['../page.vue'], resolve),
      meta: {
          title: '积分兑换',
          keepAlive: false
      }
  },
  {
    path: '/dataList/integral',
    component: resolve => require(['../redemptionRecord.vue'], resolve),
    meta: {
        title: '积分兑换',
        keepAlive: false
    }
  }
]